import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataIoService } from './data-io.service';
import { MenuService } from './menu.service';
@Injectable({
  providedIn: 'root'
})

export class IconBarService {
	events$ :Subject<string>;
	knownIcons:Array<string>;
	iconStates:Map<string,string>;
	_barEnabled : boolean = true;
	constructor(
		private ioService:DataIoService,
		private menu:MenuService
		) {
		this.iconStates = new Map<string,string>();
		this.savedStates = new Map<string,Map<string,string>>();
		this.knownIcons = new Array<string>();
		this.events$ = new Subject<string>();

	}
	evaluate(){
		if(this.menu.getCurrentNode().isDescendantOf('chimneysweepMainMenu')){
			this.disableAll();
		}
		this.blinkIcon('heating');
		let dhwValue = this.ioService.deviceInfo().getScale('d006').getCurrentValue();
		if(dhwValue == 34){
			this.disableIcon('dhw');
		}else{
			this.enableIcon('dhw');
		}
		let ecoMode=this.ioService.deviceInfo().getRawValue('smarteco_mode') == 'AICI_ON_NORMAL';
		if(ecoMode){
			this.enableIcon('ecomode');
		}else{
			this.disableIcon('ecomode');
		}
		if(this.timeControlled()){
			this.enableIcon('operationTime');
		}else{
			this.disableIcon('operationTime');
		}
		this.enableIcon('burner');
		
	}
	timeControlled():boolean{
		return this.ioService.getDeviceInfo().getValue('heizmodus')=='Zeitgesteuert';
	}
	getState(icon:string){
		if(this.knownIcons.includes(icon)){
			if(this.iconStates.has(icon)){
				return this.iconStates.get(icon);
			}
		}else{
			return 'off';
		}
	}

	savedStates:Map<string,Map<string,string>>=undefined;
	saveState(name:string):void{
		let states = new Map<string,string>();
		for(let icon of this.knownIcons){
			states.set(icon,this.iconStates.get(icon));
		}
		this.savedStates.set(name,states);
	}

	restoreState(name:string):void{
		if(this.savedStates.has(name)){
			let states = this.savedStates.get(name);
			for(let icon of this.knownIcons){
				this.iconStates.set(icon,states.get(icon));
			}
		}
	}
	barEnabled(){
		return this._barEnabled;
	}
	getEvents():Subject<string>{
		return this.events$;
	}
	disable(){
		this._barEnabled = false;
		this.events$.next('disable_icon_bar');
	}
	enable(){
		this._barEnabled = true;
		this.events$.next('enable_icon_bar');
	}
	disableAll(){
		for(let icon of this.knownIcons){
			this.iconStates.set(icon,'off');
		}
	}
	blinkIcon(icon:string){
		this.iconStates.set(icon,'blinking');
	}
	enableIcon(icon:string){
		this.iconStates.set(icon,'on');
	}
	disableIcon(icon:string){
		this.iconStates.set(icon,'off');
	}
	knowsOf(icon:string){
		return this.knownIcons.includes(icon);
	}
	registerIcons(icons:Array<string>):void{
		for(let icon of icons){
			if(!this.knowsOf(icon)){
				this.knownIcons.push(icon);
				this.iconStates.set(icon,'off');
			}
		}

	}
}
